<template>
    <div>
        <ul class="countdown-timer">
            <li v-for="slice in clock">
                <div class="ct-time">{{slice.time}}</div>
                <div class="ct-label">{{slice.label}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
    //import countdown from '../../vendor/countdown.min.js';
    export default {
        name: 'countdown',
        props: {
            end: {default: null},
        },
        watch: {
            start() {
                this.refresh();
            },
            end() {
                this.refresh();
            },
        },
        data() {
            return {
                clock: [],
                endTime: null,
            };
        },
        methods: {
            getTimeRemaining(starttime, endtime){
                let t = endtime - starttime;
                let seconds = Math.floor( (t/1000) % 60 );
                let minutes = Math.floor( (t/1000/60) % 60 );
                let hours = Math.floor( (t/(1000*60*60)) % 24 );
                let days = Math.floor( t/(1000*60*60*24) );

                return {
                    'total': t,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                };
            },
            refresh() {
                let result = this.getTimeRemaining(Date.now(), this.endTime);
                this.clock = [];
                let hadOne = false;
                for(let t in {'days': null, 'hours': null, 'minutes': null, 'seconds': null})
                {
                    if(result[t] !== undefined)
                    {
                        if(result[t] > 0 || hadOne)
                        {
                            this.clock.push({
                                time: result[t],
                                label: t,
                            });
                            hadOne = true;
                        }
                    }
                }
            }
        },
        mounted() {
            this.interval = setInterval(this.refresh, 1000);
            this.endTime = Date.now() + this.end;
            this.refresh();
        },
        beforeDestroy() {
            clearInterval(this.interval);
        }
    }
</script>

<style>
    ul.countdown-timer {
        list-style-type: none;
        padding: 0;
    }

    ul.countdown-timer > li {
        display: inline-block;
        padding: 10px;
        color: white;
        text-align: center;
        margin-left: 5px;
        width: 75px;

        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#aebcbf+0,6e7774+50,0a0e0a+51,0a0809+100;Black+Gloss */
        background: rgb(174,188,191); /* Old browsers */
        background: -moz-linear-gradient(top,  rgba(174,188,191,1) 0%, rgba(110,119,116,1) 50%, rgba(10,14,10,1) 51%, rgba(10,8,9,1) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  rgba(174,188,191,1) 0%,rgba(110,119,116,1) 50%,rgba(10,14,10,1) 51%,rgba(10,8,9,1) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  rgba(174,188,191,1) 0%,rgba(110,119,116,1) 50%,rgba(10,14,10,1) 51%,rgba(10,8,9,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#aebcbf', endColorstr='#0a0809',GradientType=0 ); /* IE6-9 */
    }

    .ct-time {
        font-size: 42px;
        font-weight: bold;
        text-shadow: -1px 0 #555, 0 1px #555, 1px 0 #555, 0 -1px #555;
        line-height: 1em;
    }

    .ct-label {
        font-size: 10px;
        text-transform: uppercase;
        text-shadow: -1px 0 #333, 0 1px #333, 1px 0 #333, 0 -1px #333;
        line-height: 1em;
    }
</style>
